import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/period/types')
};